import { RateType, ServiceType } from '@wix/ambassador-bookings-services-v2-service/types';
import { BOOKINGS_APP_DEF_ID } from '@wix/bookings-catalog-calendar-viewer-utils';
const EVENT_ORIGIN_BOOKINGS = 'Bookings';
export const basePayload = {
  origin: EVENT_ORIGIN_BOOKINGS,
  appDefId: BOOKINGS_APP_DEF_ID
};
const getVariant = serviceType => {
  switch (serviceType) {
    case ServiceType.APPOINTMENT:
      return 'PRIVATE';
    case ServiceType.CLASS:
      return 'GROUP';
    case ServiceType.COURSE:
    default:
      return 'COURSE';
  }
};
const getServiceTrackingEventFromService = (service, businessName) => ({
  id: service.id,
  name: service.name,
  brand: businessName,
  category: '',
  variant: getVariant(service.type),
  ...getServicePriceAndCurrency(service)
});
const getServicePriceAndCurrency = service => {
  const {
    fixed,
    varied,
    rateType
  } = service.payment;
  if (rateType === RateType.FIXED) {
    var _price, _price2;
    return {
      price: Number((_price = fixed.price) == null ? void 0 : _price.value),
      currency: (_price2 = fixed.price) == null ? void 0 : _price2.currency
    };
  }
  if (rateType === RateType.VARIED) {
    var _varied$defaultPrice, _varied$defaultPrice2;
    return {
      price: Number(varied == null || (_varied$defaultPrice = varied.defaultPrice) == null ? void 0 : _varied$defaultPrice.value),
      currency: varied == null || (_varied$defaultPrice2 = varied.defaultPrice) == null ? void 0 : _varied$defaultPrice2.currency
    };
  }
  return {};
};
export const getTrackingInfoForBookButtonClick = _ref => {
  let {
    service,
    businessName
  } = _ref;
  return {
    eventId: 'InitiateCheckout',
    payload: {
      ...basePayload,
      contents: [getServiceTrackingEventFromService(service, businessName)]
    }
  };
};
export const getTrackingInfoForNavigateToServicePageClick = _ref2 => {
  let {
    service,
    businessName
  } = _ref2;
  return {
    eventId: 'ClickProduct',
    payload: {
      ...basePayload,
      ...getServiceTrackingEventFromService(service, businessName),
      list: 'Service Widget',
      position: 0
    }
  };
};
export const getTrackingInfoForServicePageLoads = _ref3 => {
  let {
    service,
    businessName
  } = _ref3;
  return {
    eventId: 'ViewContent',
    payload: {
      ...basePayload,
      ...getServiceTrackingEventFromService(service, businessName)
    }
  };
};
export const getTrackingInfoForCalendarNextButtonClick = _ref4 => {
  let {
    services,
    businessName
  } = _ref4;
  return {
    eventId: 'CustomEvent',
    payload: {
      ...basePayload,
      contents: services.map(service => getServiceTrackingEventFromService(service, businessName)),
      eventCategory: 'Enhanced Ecommerce - Bookings',
      eventAction: 'Select Date'
    }
  };
};
export const getTrackingInfoForFormNextButtonClick = _ref5 => {
  let {
    service: {
      id,
      name,
      type,
      price,
      currency
    },
    businessName
  } = _ref5;
  return {
    eventId: 'CustomEvent',
    payload: {
      ...basePayload,
      contents: [{
        id,
        name,
        price,
        currency,
        category: '',
        brand: businessName,
        variant: getVariant(type)
      }],
      eventCategory: 'Enhanced Ecommerce - Bookings',
      eventAction: 'Add Personal Info'
    }
  };
};
export const getTrackingInfoForBookingMade = _ref6 => {
  let {
    serviceName,
    pricingPlanName
  } = _ref6;
  const pricingPlanLabel = pricingPlanName ? " / Pricing Plans " + pricingPlanName : '';
  const eventLabel = "Bookings " + serviceName + pricingPlanLabel;
  return {
    eventId: 'CustomEvent',
    payload: {
      ...basePayload,
      eventCategory: 'Enhanced Ecommerce - Bookings',
      eventAction: 'Booking Made',
      eventLabel
    }
  };
};
export const getTrackingInfoForSchedule = () => {
  return {
    eventId: 'Schedule',
    payload: {
      ...basePayload
    }
  };
};
//# sourceMappingURL=analyticsAdapter.js.map